// src/config/api.js
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const LOGIN_ENDPOINT = `${BASE_URL}/login/login.php`;

export const ORG_SAVE_ENDPOINT = `${BASE_URL}/organizations/save.php`;
export const ORG_SEARCH_ENDPOINT = `${BASE_URL}/organizations/search.php`;
export const ORG_DUPLICATE_CHECK_ENDPOINT = `${BASE_URL}/organizations/check_duplicate.php`;

export const USER_SAVE_ENDPOINT = `${BASE_URL}/user/save.php`;
export const USER_SEARCH_ENDPOINT = `${BASE_URL}/user/search.php`;

export const USER_STATUS_UPDATE_ENDPOINT = `${BASE_URL}/user/update_status.php`;
export const USER_PROFILE_ENDPOINT = `${BASE_URL}/user/get_profile.php`;

// ✅ Add these two lines below:
export const ORG_LIST_ENDPOINT = `${BASE_URL}/organizations/list.php`;
export const ORG_USER_ASSIGN_ENDPOINT = `${BASE_URL}/organizations/assignorganizationstouser.php`;
export const ORG_USER_REMOVE_ENDPOINT = `${BASE_URL}/organizations/removeOrganizationFromUser.php`;

export const MODULE_LIST_ENDPOINT = `${BASE_URL}/modules/list_modules.php`;
export const MODULE_ASSIGN_ENDPOINT = `${BASE_URL}/modules/assign_modules.php`;
export const MODULE_REMOVE_ENDPOINT = `${BASE_URL}/modules/remove_module.php`;

export const CUSTOMER_LIST_ENDPOINT = `${BASE_URL}/customer/list_customers.php`;

export const CUSTOMER_ASSIGN_ENDPOINT = `${BASE_URL}/customer/assign_customers.php`;
export const CUSTOMER_REMOVE_ENDPOINT = `${BASE_URL}/customer/remove_customer.php`;

export const WABA_LIST_ENDPOINT = `${BASE_URL}/waba/list_waba_messages.php`;
export const WABA_ASSIGN_ENDPOINT = `${BASE_URL}/waba/assign_waba.php`;
export const WABA_REMOVE_ENDPOINT = `${BASE_URL}/waba/remove_waba.php`;

export const ACCOUNT_SEARCH_ENDPOINT = `${BASE_URL}/account/search.php`;
export const ACCOUNT_CREATE_ENDPOINT = `${BASE_URL}/account/create.php`;
export const ACCOUNT_DUPLICATE_CHECK_ENDPOINT = `${BASE_URL}/account/account_name_check.php`;
export const ACCOUNT_DETAILS_ENDPOINT = `${BASE_URL}/account/view.php`;
export const ACCOUNT_UPDATE_ENDPOINT = `${BASE_URL}/account/account_update.php`;
export const ACCOUNT_ASSIGNMENT_ENDPOINT = `${BASE_URL}/account/access_refresh.php`;

export const PINCODE_LOOKUP_ENDPOINT = `${BASE_URL}/account/pincode.php`;

export const SALES_ORDER_CREATE_ENDPOINT = `${BASE_URL}/so/so_create.php`;
export const SALES_ORDER_SEARCH_ENDPOINT = `${BASE_URL}/so/so_list.php`;
export const SALES_ORDER_CUSTOMER_LIST = `${BASE_URL}/so/customer_list.php`;
export const DISPATCH_PENDING_FILTERS_API = `${BASE_URL}/so/dispatch_pending_report.php`;


export const SALES_ORDER_HEADER_UPDATE = `${BASE_URL}/so/update_header.php`;
export const SALES_ORDER_ATTACHMENT_UPDATE = `${BASE_URL}/so/update_attachments.php`;
export const SALES_ORDER_ITEM_UPDATE = `${BASE_URL}/so/update_items.php`;
export const SALES_ORDER_ATTACHEMENT_DELETE = `${BASE_URL}/so/delete_attachement.php`;

export const SALES_ORDER_BY_CUSTOMER = `${BASE_URL}/planning/customer_orders.php`;
export const SALES_ORDER_MATERIALS = `${BASE_URL}/planning/get_materials_by_sales_order.php`;

export const SALES_ORDER_DESTINATIONS = `${BASE_URL}/planning/destination_list.php`;
export const SALES_ORDER_PLAN_CREATE = `${BASE_URL}/planning/plan_create.php`;
export const SALES_ORDER_EXISTING_PLANS = `${BASE_URL}/planning/sales_order_existing_plans.php`;
export const SALES_ORDER_EXISTING_PLANS_V1 = `${BASE_URL}/planning/sales_order_existing_plans_v1.php`;


export const SALES_ORDER_SEARCH_API = `${BASE_URL}/planning/search.php`;
export const SALES_ORDER_PLAN_API = `${BASE_URL}/planning/plan.php`;
export const SALES_ORDER_INVOICE_SUMMARY = `${BASE_URL}/planning/get_so_invoiced_qty.php`;

export const MATERIAL_LIST_ENDPOINT = `${BASE_URL}/materials/list.php`;

export const DISPATCH_PLANNING_AGAINST_PLLANING_ID = `${BASE_URL}/dispatch_planning/fetch_single_planning.php`;

export const TRANSPORTER_LIST = `${BASE_URL}/transporter/list.php`;
export const SUB_TRANSPORTER_LIST = `${BASE_URL}/transporter/sub_list.php`;

export const VEHICLE_DRIVER_LIST = `${BASE_URL}/transporter/list_by_vehicle.php`;
export const VEHICLE_DRIVER_SAVE = `${BASE_URL}/transporter/save_driver.php`;
export const VEHICLE_LIST_API = `${BASE_URL}/transporter/vehicle_list.php`;
export const VEHICLE_SAVE_API = `${BASE_URL}/transporter/save_driver.php`;
export const VEHICLE_DRIVER_UPDATE = `${BASE_URL}/transporter/update_driver.php`;

export const DRIVER_LIST_API = `${BASE_URL}/transporter/list_by_vehicle.php`;

export const CREATE_DISPATCH_PLANNING = `${BASE_URL}/dispatch/create.php`;

export const LOGIN_ORG_LIST_ENDPOINT = `${BASE_URL}/organizations/login_org_list.php`;

export const FETCH_DATA_FOR_UPDATE_DISPATCH_PLANNING = `${BASE_URL}/dispatch/get_by_id.php`;

export const UPDATE_DISPATCH_TRANSPORT = `${BASE_URL}/dispatch/update_transport.php`;
export const UPDATE_DISPATCH_FUEL = `${BASE_URL}/dispatch/update_fuel_info.php`;
export const UPDATE_DISPATCH_INFO = `${BASE_URL}/dispatch/update_dispatch_info.php`;


export const DISPATCH_SEARCH_FOR_INVOICE = `${BASE_URL}/invoice/search.php`;
export const SALES_INVOICE_SEARCH = `${BASE_URL}/invoice/search.php`;

export const SAVE_INVOICE = `${BASE_URL}/invoice/save_invoice.php`;
export const DISPATCH_DETAILS_BY_IDS_API = `${BASE_URL}/invoice/get_dispatch_details.php`;
//export const GET_INVOICE_PLAN_DETAILS_API = `${BASE_URL}/invoice/get_dispatch_details.php`;
export const SALES_INVOICE_DETAILS_API=  `${BASE_URL}/invoice/view_invoice_details.php`;
export const SALES_INVOICE_DELETE_API=  `${BASE_URL}/invoice/sales_invoice_delete.php`;

export const CHECK_TALLY_INVOICE_UNIQUE_API = `${BASE_URL}/invoice/check_tally_invoice_unique.php`;


export const SALES_INVOICE_UPDATE_ITEM_API = `${BASE_URL}/invoice/update_item.php`;
export const SALES_ORDER_SEARCH_API_WITH_FILTERS = `${BASE_URL}/planning/search_with_filters.php`;

export const INVOICE_SUPPORTING_DOCUMENT_ENDPOINT = `${BASE_URL}/invoice/get_account_documents.php`;


export const RESET_PASSWORD_ENDPOINT = `${BASE_URL}/login/reset_password.php`;
export const VERIFY_RESET_PASSWORD_ENDPOINT = `${BASE_URL}/login/resetpassword.php`;
export const SEND_OTP_ENDPOINT = `${BASE_URL}/login/otp.php`;




//////////// DASH BOARD ENDPOINTS ////////////

export const SALES_ORDER_COUNT_ENDPOINT
    = `${BASE_URL}/dashboard/so_summary.php`;
    export const SO_PLANNING_SUMMARY_API = `${BASE_URL}/dashboard/so_planning_summary.php`;


export const SALES_ORDER_CLOSE_PLANS = `${BASE_URL}/planning/close_plans.php`;

export const SALES_ORDER_PENDING_PLANS = `${BASE_URL}/planning/pending_plans.php`;





///////////////////
export const TRANSPORT_SEARCH_API = `${BASE_URL}/transporter/search.php`;
export const TRANSPORT_SAVE_API = `${BASE_URL}/transporter/save.php`;   
export const TRANSPORT_SUB_SAVE_API = `${BASE_URL}/transporter/save_sub.php`;

export const TRANSPORTER_UPDATE = `${BASE_URL}/transporter/update.php`;
export const SUB_TRANSPORTER_UPDATE = `${BASE_URL}/transporter/update_sub.php`;




export const GET_DOCUMENT_LIST_ENDPOINT = `${BASE_URL}/account/document_list.php`;
export const ADD_DOCUMENT_ENDPOINT = `${BASE_URL}/account/add_document.php`;


//////////////gst api 
export const GST_LOOKUP_ENDPOINT = 'https://api.whitebooks.in/public/search';
export const GST_API_HEADERS = {
  'client_id': 'GSTP61dcf250-017f-45d9-94bb-c5aeb233e3cf',
  'client_secret': 'GSTP0c4f12ef-9994-4759-a75c-cc1f8e1fa035',
};
export const GST_EMAIL = 'toorant.c@gmail.com';
///////////////////////
/////////////////production api
export const SAVE_PRODUCTION_ENDPOINT = `${BASE_URL}/production/save.php`;
export const SEARCH_PRODUCTION_ENDPOINT = `${BASE_URL}/production/search_production.php`;




//////////////Loading Point API
export const SAVE_LOADING_POINT_ENDPOINT = `${BASE_URL}/production/save_loading_point.php`;
export const GET_LOADING_POINTS_ENDPOINT = `${BASE_URL}/production/get_loading_points.php`;
export const UPDATE_LOADING_POINT_ENDPOINT = `${BASE_URL}/production/update_loading_point.php`;
export const DELETE_LOADING_POINT_ENDPOINT = `${BASE_URL}/production/delete_loading_point.php`;

///////////// accounts/ waba acces 

export const USER_LIST_ENDPOINT = `${BASE_URL}/user/user_list_for_new_account_waba_card.php`;

export const UPDATE_PLANNING_PRIORTY = `${BASE_URL}/planning/update_priority.php`;








/////////////////////stock report 
export const STOCK_REPORT_ENDPOINT =  `${BASE_URL}/production/stock_reports/basic_stockreport.php`;

////////////////waba


export const SO_CREATE_WABA_ENDPOINT  = `${BASE_URL}/so/waba/so_create_waba.php`;
export const SO_UPDATE_WABA_ENDPOINT = `${BASE_URL}/so/waba/so_update_waba.php`;

export const WABA_PLANNING_TRIGGER = `${BASE_URL}/planning/waba/waba_planning.php`;

export const WABA_DISPATCH_TRIGGER = `${BASE_URL}/dispatch/waba/waba_dispatch.php`;

export const INVOICE_WABA_ENDPOINT = `${BASE_URL}/invoice/waba/invoice_waba.php`;


export const DELETE_DISPATCH_API = `${BASE_URL}/dispatch/delete_dispatch.php`;



export const USERS_MARKETING_LIST_ENDPOINT = `${BASE_URL}/user/marketing_user_list.php`;
export const WABA_ACCESS_SAVE_ENDPOINT = `${BASE_URL}/waba/assign_waba_custom.php`;
export const WABA_ACCESS_LIST_ENDPOINT = `${BASE_URL}/waba/marketing_user_list.php`;
export const WABA_ACCOUNT_ASSIGNEES_MAP_ENDPOINT = `${BASE_URL}/waba/account_assignees_map.php`;


export const PACKING_TYPE_LIST_ENDPOINT = `${BASE_URL}/packing_types/list.php`;
export const SALES_ORDER_ATTACHMENT_DOWNLOAD = `${BASE_URL}/so/attachment_download.php`;

export const SALES_ORDER_PLAN_UPDATE = `${BASE_URL}/planning/plan_update.php`;
export const SALES_ORDER_PLAN_DELETE = `${BASE_URL}/planning/plan_delete.php`;

export const LOGISTIC_PLANNING_FILTERS_API = DISPATCH_PENDING_FILTERS_API;


export const SO_PLAN_DISPATCH_REPORT_API = `${BASE_URL}/so/so_plan_dispatch_report.php`;
export const SO_PLAN_DISPATCH_DETAILS_API = `${BASE_URL}/so/so_plan_dispatch_details.php`;
export const SO_PLAN_DISPATCH_DETAILS_API_R1 = `${BASE_URL}/so/so_plan_dispatch_details_r1.php`;





///////////////////////////CREDIT NOTE 

export const SALES_INVOICE_DETAILS_BY_NO_API = `${BASE_URL}/creditnote/details-by-no.php`;
export const CREDIT_NOTE_CREATE_API = `${BASE_URL}/creditnote/create.php`;


export const CREDIT_NOTE_SEARCH_API   = `${BASE_URL}/creditnote/report-search.php`;
export const CREDIT_NOTE_DETAILS_API  = `${BASE_URL}/creditnote/1details.php`;
export const CREDIT_NOTE_DELETE_API = `${BASE_URL}/creditnote/delete.php`;
export const INVOICE_REPORT_SEARCH_API   = `${BASE_URL}/creditnote/invoice_report.php`;
export const INVOICE_ACTUAL_RECEIPT_SAVE_API = `${BASE_URL}/creditnote/invoice_actual_save.php`;
export const INVOICE_ACTUAL_RECEIPT_UPDATE_API = `${BASE_URL}/creditnote/invoice_actual_update.php`;